'use client'

import { motion } from 'framer-motion'
import CountUp from 'react-countup'
import FullBleedSection from './FullBleedSection'

export default function SellingProposition() {
  return (
    <FullBleedSection className="relative bg-gray-100 py-20">
      <div className="mx-auto max-w-7xl md:px-2 lg:px-0">
        {/* Title Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            Was uns von anderen <span className="text-[#ff4500]"> unterscheidet </span>
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Wir denken ganzheitlich und drücken niemandem eine One-fits-all-Lösung auf
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="mb-20 grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Stat 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            <div className="text-5xl leading-none font-bold text-[#ff4500] lg:text-7xl">
              <CountUp end={1000} duration={5} separator="." enableScrollSpy scrollSpyOnce />
              <span className="text-3xl md:text-4xl">+</span>
            </div>
            <h3 className="mt-4 text-xl font-semibold">Installierte Solaranlagen</h3>
            <p className="mt-2 text-gray-600">
              Damit sind wir einer der Marktführer in Deutschland
            </p>
          </motion.div>

          {/* Stat 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-center"
          >
            <div className="text-5xl leading-none font-bold text-[#ff4500] lg:text-7xl">
              <CountUp end={20} duration={4} enableScrollSpy scrollSpyOnce />
              <span className="text-xl"> Jahre </span>
            </div>
            <h3 className="mt-4 text-xl font-semibold">Branchen-Erfahrung</h3>
            <p className="mt-2 text-gray-600">Wir sind Ihr Fachbetrieb </p>
          </motion.div>

          {/* Stat 3 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-center"
          >
            <div className="text-5xl leading-none font-bold text-[#ff4500] lg:text-7xl">
              <CountUp end={13} duration={6} enableScrollSpy scrollSpyOnce />
              <span className="text-xl"> GWh</span>
            </div>
            <h3 className="mt-4 text-xl font-semibold">Selbsterzeugte Energie</h3>
            <p className="mt-2 text-gray-600">Von unseren Kunden pro Jahr</p>
          </motion.div>
        </div>

        {/* Features List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mx-auto max-w-7xl"
        >
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {/* Left Column */}
            <div>
              <ul className="space-y-4 text-lg md:text-xl">
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir bieten effiziente Energielösungen <br /> an, die sich jeder leisten kann
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Alle Energielösungen aus einer Hand
                </motion.li>
              </ul>
            </div>
            {/* Middle Column */}
            <div>
              <ul className="space-y-4 text-lg md:text-xl">
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir bieten Qualität zu einem Preis,
                  <br /> den kaum jemand anbieten kann
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir bieten Lösungen, die hoch-effizient, aber vielen noch unbekannt sind
                </motion.li>
                {/* <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir denken ganzheitlich und drücken niemandem eine One-fits-all-Lösung auf
                </motion.li> */}
              </ul>
            </div>
            {/* Right Column */}
            <div>
              <ul className="space-y-4 text-lg md:text-xl">
                <motion.li
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir bieten alternative Lösungen <br /> mit den günstigsten Preisen bundesweit
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="flex items-start px-6"
                >
                  <span className="mr-3 text-[#ff4500]">✓</span>
                  Wir arbeiten mit deutschen Handwerkern zusammen
                </motion.li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </FullBleedSection>
  )
}
